import React, { useRef } from "react";
import Header from "./Header";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import { testimonials } from "../../Data/data";

import star from '../../assets/icons/star.png'

const Testinomial = () => {
     
  const swiperRef = useRef(null);

  return (
    <div className="w-full h-full bg-black px-[4rem] py-[5rem] flex justify-center items-cetner gap-[4rem] flex-wrap">
      <Header
        title={"What Our Clients Say"}
        subtitle={"Trusted by Property Owners Across the Bay Area"}
        description={
          "Our clients consistently rely on us for professional, reliable, and proactive property management. We handle everything from residential homes to commercial properties with transparency, integrity, and a focus on maximizing returns. Here’s what they have to say about working with us."
        }
      />
      {/* Slider  */}
       <div className="w-full flex justify-center relative">
  <Swiper
    modules={[Navigation, Autoplay]}
    onSwiper={(swiper) => (swiperRef.current = swiper)}
    slidesPerView={1} // default for mobile
    spaceBetween={20}
    loop={true}
    centeredSlides={true} // center first slide on mobile
    autoplay={{ delay: 2500, disableOnInteraction: false }}
    breakpoints={{
      480: { slidesPerView: 1, spaceBetween: 10, centeredSlides: true },
      640: { slidesPerView: 2, spaceBetween: 15, centeredSlides: false },
      768: { slidesPerView: 2, spaceBetween: 20, centeredSlides: false },
      1024: { slidesPerView: 3, spaceBetween: 20, centeredSlides: false },
      1280: { slidesPerView: 3, spaceBetween: 20, centeredSlides: false },
    }}
    navigation={false}
    className="crafted-swiper w-full max-w-[1280px]"
  >
    {testimonials?.map((item, index) => (
      <SwiperSlide key={index} className="flex justify-center ">
        {/* Fixed width card, prevent shrinking */}
      <div
  className="flex-shrink-0 bg-[#141414] border border-[#FFFFFF33] rounded-lg h-[400px] w-[100%] sm:w-[400px] md:w-[400px]
             flex flex-col justify-between p-[2rem]"
>
  {/* Stars */}
  <div className="flex items-center gap-[0.5rem]">
    {[1,2,3,4,5].map((data,i)=>(
      <img key={i} src={star} alt="" className="w-[2.5rem] h-[2.5rem]" />
    ))}
  </div>

  {/* Title & Content */}
  <div className="flex flex-col gap-[1rem]">
    <h1 className="text-[26px] font-bold text-gradient">{item.title}</h1>
    <p className="text-[18px] font-light text-white min-h-[120px]">
      {item.detail}
    </p>
  </div>

  {/* User Info */}
  <div className="flex gap-[1rem] items-center mt-2">
    <img src={item.img} alt="" className="w-[60px] h-[60px] rounded-full" />
    <div className="flex flex-col justify-center">
      <h1 className="text-[20px] font-bold text-gradient">{item.name}</h1>
      <span className="text-[18px] font-light text-white">{item.city}</span>
    </div>
  </div>
</div>
      </SwiperSlide>
    ))}
  </Swiper>

  {/* Prev Button */}
  <button
    onClick={() => swiperRef.current?.slidePrev()}
    className="absolute md:top-1/2 top-[103%] left-0 sm:left-[-30px] md:left-[40px] w-10 h-10 sm:w-12 sm:h-12 gradient rounded-full flex items-center justify-center -translate-y-1/2 z-20 shadow-lg hover:scale-110 transition-all"
  >
    <FaAngleLeft className="text-black text-xl sm:text-2xl" />
  </button>

  {/* Next Button */}
  <button
    onClick={() => swiperRef.current?.slideNext()}
    className="absolute md:top-1/2 top-[103%] right-0 sm:right-[-30px] md:right-[50px] w-10 h-10 sm:w-12 sm:h-12 gradient rounded-full flex items-center justify-center -translate-y-1/2 z-20 shadow-lg hover:scale-110 transition-all"
  >
    <FaAngleRight className="text-black text-xl sm:text-2xl" />
  </button>
</div>
    </div>
  );
};

export default Testinomial;
